import React from 'react';
import { Link } from 'react-router-dom';
export interface Crumb {
  label: string;
  href?: string;
}
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  lead: string;
  crumbs: Crumb[];
  children?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  lead,
  crumbs,
  children
}: PageHeaderProps) {
  return <section aria-labelledby="page-title" className="rp-grid-lines-dark w-full bg-navy" data-id="element-547" data-mp="3j5s1lbefpket">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-8 lg:px-10 lg:pb-16 lg:pt-10" data-id="element-548" data-mp="2vfo1he0gg2sk">
        <nav aria-label="Breadcrumb" data-id="element-549" data-mp="2qhw8shrzkcnb">
          <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[10.5px] tracking-[0.08em] text-aluminum/80" data-id="element-550" data-mp="347pwgwrr8qvg">
            {crumbs.map((crumb, i) => <li key={crumb.label} className="flex items-center gap-2" data-id="element-551" data-mp="2zewrq8wadijd" data-mpi={i}>
                {crumb.href ? <Link to={crumb.href} className="inline-flex min-h-[32px] items-center underline decoration-white/20 underline-offset-4 transition-colors duration-150 ease-precise hover:text-white" data-id="element-552" data-mp="2bp2fntjsjy06">
                    {crumb.label}
                  </Link> : <span aria-current="page" className="text-white" data-id="element-553" data-mp="3qgipt8zwnxsz">
                    {crumb.label}
                  </span>}
                {i < crumbs.length - 1 ? <span aria-hidden="true" className="text-copper" data-id="element-554" data-mp="2xsmvuc1q0jzw">
                    /
                  </span> : null}
              </li>)}
          </ol>
        </nav>

        <p className="mt-8 flex items-center gap-3 font-mono text-[10px] tracking-label text-copper" data-id="element-555" data-mp="37prmao2ln1mi">
          <span aria-hidden="true" className="h-px w-8 bg-copper" data-id="element-556" data-mp="3cpx7pmi9zrw5" />
          {eyebrow.toUpperCase()}
        </p>
        <h1 id="page-title" className="mt-5 max-w-[22ch] font-display text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.06] tracking-[-0.02em] text-white" data-id="element-557" data-mp="mz0jj5zs6yuo">
          {title}
        </h1>
        <p className="rp-measure mt-6 text-[16px] leading-[1.7] text-aluminum" data-id="element-558" data-mp="2o0qasjy8dwsm">
          {lead}
        </p>
        {children ? <div className="mt-8" data-id="element-559" data-mp="2j5b0u33cgl1h">{children}</div> : null}
      </div>
    </section>;
}